export const INFO_TEXT = `רוצים לראות את מחירי שכר הדירה בסביבתכם?\nסמנו את תקופת הזמן אותה תרצו לבדוק, בחרו את טווח\nמספר החדרים והופ! כל הנכסים מתעדכנים על המפה!\nלהצגת הנתונים יש ללחוץ על הנכס הרצוי במפה.`;
export const INFO_BUTTON_TEXT = `הבנתי`;
